module.exports = __webpack_public_path__ + "img/severn-map.58926f67.jpeg";